export default {
    login: {
        title: 'Accedi',
        email: 'Email',
        password: 'Password',
        submit: 'Accedi',
        remember: 'Ricordami',
        forgot: 'Password dimenticata?',
        error: 'Credenziali non valide'
    },
    logout: {
        title: 'Logout',
        confirm: 'Sei sicuro di voler uscire?',
        success: 'Logout effettuato con successo'
    },
    errors: {
        unauthorized: 'Non autorizzato',
        sessionExpired: 'Sessione scaduta'
    }
}; 